/* PROA-OLHO-MAIS (11/10/2026): as medidas finas, à parte do olho para não passar o tecto dele (6 KB).
   Pedido do Silva: «mede tudo que for possível». Para cada VISTA (id ao acaso, só desta página):
   · toque lento (≥200 ms): atraso, processamento e apresentação, o evento, o alvo e o guião mais longo do frame;
   · deslocamentos (CLS): o total e o NÓ que mais mexeu, quantos e quando;
   · maior pintura (LCP): elemento, imagem e as partes (ttfb, atraso a pedir, carga, desenho);
   · navegação: ttfb, DOMContentLoaded, load, KB e o tipo (normal, recarregar, voltar, pré-render);
   · frames longos (≥150 ms): quantos, o pior e o guião/invocador culpado;
   · a versão do Sonar carregada.
   ⛔ Igual ao olho: só com consentimento (confirmado AO ENVIAR), nada de cookies, localStorage, IP ou texto da
   cliente. Robôs não se medem. Tecto de 4 KB comprimido (a trava do tema recusa acima). */
(function () {
  "use strict";
  var CFG;
  try { CFG = JSON.parse(document.getElementById("proa-olho-cfg").textContent); } catch (e) { return; }
  if (!CFG || !CFG.endereco || !window.PerformanceObserver) return;
  // a MESMA lista fechada do olho: nunca «bot» solto (apanhava o telemóvel CUBOT)
  if (navigator.webdriver === true || /(meta-externalads|facebookexternalhit|facebookcatalog|googlebot|adsbot-google|storebot-google|bingbot|yandexbot|applebot|petalbot|semrushbot|ahrefsbot|bytespider|gptbot|claudebot|perplexitybot|headlesschrome|lighthouse)/i.test(navigator.userAgent || "")) return;

  var VS = ("0000000" + Math.floor(Math.random() * 4294967295).toString(16)).slice(-8);
  function sonar() {
    try { var s = document.querySelector('script[src*="/sonar-pesquisa-"]'); var m = s && s.src.match(/sonar-pesquisa-(\d+)/); return m ? m[1] : undefined; } catch (e) {}
  }
  function sel(el) {
    if (!el || !el.tagName) return undefined;
    var s = el.tagName.toLowerCase();
    if (el.id) return (s + "#" + el.id).slice(0, 120);
    if (typeof el.className === "string" && el.className.trim()) s += "." + el.className.trim().split(/\s+/).slice(0, 2).join(".");
    return s.slice(0, 120);
  }
  function fich(u) { try { var x = new URL(u, location.href); return (x.host === location.host ? "" : x.host + "/") + x.pathname.split("/").pop(); } catch (e) {} }
  var R = Math.round;
  function T(x) { return x > 0 && isFinite(x) ? Math.min(R(x), 600000) : 0; } // o servidor recusa o envio INTEIRO acima de 600000 ou com NaN

  var fila = [], enviados = 0;
  function por(ev) { if (enviados + fila.length >= 60) return; ev.k = "medida"; ev.vs = VS; var v = sonar(); if (v) ev.sv = v; fila.push(ev); }
  function consente() {
    try { var cp = window.Shopify && window.Shopify.customerPrivacy; return !!(cp && cp.analyticsProcessingAllowed && cp.analyticsProcessingAllowed()); } catch (e) { return false; }
  }
  function mandar() {
    if (!fila.length) return;
    if (!consente()) { fila.length = 0; return; }
    var w = innerWidth, v = null;
    try { v = new URLSearchParams(location.search).get("variant"); } catch (e) {}
    if (!/^\d+$/.test(v || "")) v = null; // um ?variant= que não seja número fazia o servidor recusar o envio inteiro
    var t = navigator.connection && navigator.connection.effectiveType;
    while (fila.length) {
      var lote = fila.splice(0, 20); enviados += lote.length;
      try {
        navigator.sendBeacon(CFG.endereco, JSON.stringify({
          v: 1, t: CFG.t, tp: CFG.tp, tv: CFG.tv,
          m: { product: 1, collection: 1, index: 1, search: 1, cart: 1, page: 1, blog: 1, article: 1, "404": 1, "list-collections": 1 }[String(CFG.tpl || "").split(".")[0]] ? String(CFG.tpl).split(".")[0] : "other",
          h: CFG.h || null, c: v ? location.pathname + "?variant=" + v : location.pathname,
          l: w < 400 ? "<400" : w < 768 ? "400-767" : w < 1024 ? "768-1023" : "1024+",
          d: /Mobi|Android|iPhone|iPad|iPod/.test(navigator.userAgent) ? "tel" : "pc",
          r: /^(slow-2g|2g|3g|4g)$/.test(t) ? t : null, e: lote,
        }));
      } catch (e) {}
    }
  }
  function obs(tipo, fn, extra) { try { var o = { type: tipo, buffered: true }; for (var k in extra) o[k] = extra[k]; new PerformanceObserver(function (l) { try { fn(l.getEntries()); } catch (e) {} }).observe(o); } catch (e) {} }

  // frames longos (LoAF), guardados para atribuir os toques e para o resumo da página
  var frames = [], loafN = 0, loafPior = null;
  obs("long-animation-frame", function (es) {
    for (var i = 0; i < es.length; i++) {
      var f = es[i]; frames.push(f); if (frames.length > 60) frames.shift();
      if (f.duration >= 150) { loafN++; if (!loafPior || f.duration > loafPior.duration) loafPior = f; }
    }
  });
  function guiao(f) {
    var g = null, s = (f && f.scripts) || [];
    for (var i = 0; i < s.length; i++) if (!g || s[i].duration > g.duration) g = s[i];
    return g;
  }

  // toques lentos: as entradas da MESMA interação juntam-se (o alvo e o nome vêm da primeira que os tiver)
  var toques = {}, nInp = 0;
  obs("event", function (es) {
    for (var i = 0; i < es.length; i++) {
      var e = es[i]; if (!e.interactionId || !(e.processingStart > 0)) continue;
      var t = toques[e.interactionId] || (toques[e.interactionId] = { s: e.startTime, d: 0, ps: Infinity, pe: 0 });
      if (e.duration > t.d) t.d = e.duration;
      if (e.startTime < t.s) t.s = e.startTime;
      if (e.processingStart < t.ps) t.ps = e.processingStart;
      if (e.processingEnd > t.pe) t.pe = e.processingEnd;
      if (!t.el && e.target) { t.el = sel(e.target); t.n = e.name; }
      if (!t.n) t.n = e.name;
    }
  }, { durationThreshold: 200 });
  function despejarToques() {
    var lista = [];
    for (var id in toques) if (toques[id].d >= 200) lista.push(toques[id]);
    toques = {};
    lista.sort(function (x, y) { return y.d - x.d; });
    for (var k = 0; k < lista.length && nInp < 10; k++, nInp++) { // no máximo 10 por vista, os mais lentos
      var e = lista[k], fim = e.s + e.d, g = null;
      for (var i = 0; i < frames.length; i++) { var f = frames[i]; if (f.startTime < fim && f.startTime + f.duration > e.s) { var x = guiao(f); if (x && (!g || x.duration > g.duration)) g = x; } }
      var ev = { q: "inp", ms: T(e.d), tp: e.n, el: e.el, fich: g ? fich(g.sourceURL) : undefined };
      if (isFinite(e.ps) && e.pe) { ev.a = Math.min(R(e.ps - e.s), 600000); ev.p = Math.min(R(e.pe - e.ps), 600000); ev.r = Math.min(R(fim - e.pe), 600000); }
      por(ev);
    }
  }

  // deslocamentos (CLS por janelas de sessão, como o Google), e o nó do maior
  var cls = 0, jan = 0, jIni = 0, jFim = 0, maior = null, nDesl = 0;
  obs("layout-shift", function (es) {
    for (var i = 0; i < es.length; i++) {
      var e = es[i]; if (e.hadRecentInput) continue;
      nDesl++;
      if (jan && e.startTime - jFim < 1000 && e.startTime - jIni < 5000) jan += e.value; else { jan = e.value; jIni = e.startTime; }
      jFim = e.startTime; if (jan > cls) cls = jan;
      if (!maior || e.value > maior.value) maior = e;
    }
  });

  // maior pintura e as partes dela
  var lcp = null;
  obs("largest-contentful-paint", function (es) { lcp = es[es.length - 1]; });

  var navFeito = false, ultLcp = "", ultCls = 0, ultLoaf = 0;
  function fechar() {
    try {
      var n = performance.getEntriesByType("navigation")[0];
      if (n && !navFeito && n.loadEventEnd > 0) { // só depois de a página acabar de carregar (senão eram zeros)
        navFeito = true;
        por({ q: "nav", ms: T(n.responseStart), a: T(n.domContentLoadedEventEnd), p: T(n.loadEventEnd), n: R((n.transferSize || 0) / 1024), tp: (document.prerendering || (n.activationStart > 0)) ? "prerender" : n.type });
      }
      if (lcp && ultLcp !== lcp.startTime + "|" + lcp.url) {
        ultLcp = lcp.startTime + "|" + lcp.url;
        var ttfb = n ? n.responseStart : 0, rec = lcp.url ? performance.getEntriesByName(lcp.url)[0] : null, ev = { q: "lcp", ms: T(lcp.startTime), a: T(ttfb), el: sel(lcp.element), fich: lcp.url ? fich(lcp.url) : undefined };
        if (rec && rec.requestStart > 0) { ev.p = T(rec.requestStart - ttfb); ev.r = T(rec.responseEnd - rec.requestStart); } // sem Timing-Allow-Origin não há partes
        por(ev);
      }
      if (cls > ultCls) { ultCls = cls; por({ q: "cls", v: R(cls * 10000) / 10000, n: nDesl, ms: maior ? T(maior.startTime) : undefined, el: maior && maior.sources && maior.sources[0] ? sel(maior.sources[0].node) : undefined }); }
      if (loafN > ultLoaf) { ultLoaf = loafN; var g = guiao(loafPior), inv = g && g.invoker ? String(g.invoker) : ""; if (/^https?:/.test(inv)) inv = inv.split("?")[0].split("#")[0]; por({ q: "loaf", n: loafN, ms: T(loafPior.duration), fich: g ? fich(g.sourceURL) : undefined, el: inv ? inv.slice(0, 120) : undefined, tp: g ? g.invokerType : undefined }); }
    } catch (e) {}
    despejarToques();
    mandar();
  }
  addEventListener("visibilitychange", function () { if (document.visibilityState === "hidden") fechar(); });
  addEventListener("pagehide", fechar);
})();
